import styled from 'styled-components';

const PanelHeader = styled.div`
	gap: initial;

	> div {
		display: flex;
		align-items: center;
		gap: 20px;
	}
`;

export { PanelHeader };
